import React, { useContext, useEffect, useState } from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnGetCartByGuidDTO from "../../../models/DTO/IOnGetCartByGuidDTO";
import IGetCartByGuidDTO from "../../../models/DTO/IGetCartByGuidDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import ICart from "../../../models/ICart";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";
import IOrder from "../../../models/IOrder";
import AddressDisplay from "../../shared/AddressDisplay/AddressDisplay";
import { NumericFormat } from "react-number-format";
import { Link } from "react-router-dom";
import HelperService from "../../../services/HelperService";
import {SocketContext} from "../../../contexts/SocketContext";

type Props = {
};

export const EcommerceCheckoutComplete: React.FC<Props> = (props) => {
    const location = useLocation();
    const params = useParams();
    const history = useNavigate();

    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);

    const socket = useContext(SocketContext)!;

    const [cartGuid, setCartGuid] = useState<string>();
    const [cart, setCart] = useState<ICart>();
    const [order, setOrder] = useState<IOrder>();

    useEffect(() => {
        const search = new URLSearchParams(location.search);

        const _cartGuid = search.get("g");

        setCartGuid(_cartGuid as string);

        socket.on(EndpointsEnum.CartOnGetCartByGuid, onGetCartByGuid);

        document.title = "Orderwerks >> Checkout Complete";

        return () => {
            socket.removeListener(EndpointsEnum.CartOnGetCartByGuid, onGetCartByGuid);
        };
    }, []);

    useEffect(() => {
        if (cartGuid?.length) {
            getCartByGuid();
        }
    }, [cartGuid]);

    useEffect(() => {
        if (order) {
            document.title = `Orderwerks >> Checkout Complete >> ${order.name}`;
        }
    }, [order]);

    const getCartByGuid = () => {
        if (cartGuid?.length) {
            const payload: IGetCartByGuidDTO = {
                userGuid: userModel.guid,
                userToken: userModel.token,
                supplierGuid: supplierModel.guid,
                cartGuid,
            };

            socket.emit(EndpointsEnum.CartGetCartByGuid, payload);
        }
    };

    const onGetCartByGuid = (data: IOnGetCartByGuidDTO) => {
        setCart(data.cart);
        setOrder(data.order);
    };

    const returnHome = () => {
        history("/ecomm");
    };

    const firstColWidth = "w-7r";

    return (
        <div className={"container"}>
            <div>
                <OwTitle title={"checkout_successful"} tag={"h3"} />
            </div>
            <div className={"d-flex mt-4"}>
                <div className={firstColWidth}>
                    <OwLabel isBold={true} title={"order_no"} postText={":"} className={"me-2"} />
                </div>
                <div>
                    <Link to={`/ecomm/orders/details/${order?.guid}`}>{order?.name}</Link>
                </div>
            </div>
            <div className={"d-flex mt-4"}>
                <div className={firstColWidth}>
                    <OwLabel isBold={true} title={"ship_to"} postText={":"} className={"me-2"} />
                </div>
                <div>
                    <AddressDisplay address={order?.Ship_To} showName={true} showCompanyName={true} />
                </div>
            </div>
            <div className={"d-flex mt-4"}>
                <div className={firstColWidth}>
                    <OwLabel isBold={true} title={"total"} postText={":"} className={"me-2"} />
                </div>
                <div>
                    {HelperService.formatCurrency({
                        value: order?.grand_total,
                        currency: "USD",
                        precision: supplierModel.pricing_precision || 2,
                    })}
                </div>
            </div>

            <div className={"mt-4"}>
                <OwLabel title={"click_here_to_return_home"} fn={returnHome} />
            </div>
        </div>
    );
};
